import React from 'react';
import { s } from '../Style.jsx';

const OrderItems = ({ order }) => {

    if (!order?.items?.length)
        return <></>;

    return <div style={s.box}>
        <div style={{ ...s.table, marginBottom: 0 }}>
            {order.items.map((item, i) => <div style={s.cell(i)} key={i}>
                <div style={{ width: "100%", padding: "0 10px 4px" }}>
                    {item.snapshot && <div style={{ display: "flex", alignItems: "center", gap: 10, margin: "10px 0", justifyContent: "flex-end", width: "100%" }}>
                        <span style={{ flex: 1, fontSize: 16 }}>{item.snapshot?.name}</span>
                        <span>{item.quantity}</span>
                        <span style={{ width: 60, fontWeight: "bold", textAlign: "right" }}>${item.total}</span>
                    </div>}
                    {(!!item.combo?.items?.length || !!item.options?.length) && <div style={{ margin: "10px 0" }}>
                        <div>
                            {item.combo && item.combo.items.map((comboItem, j) => <div style={{ width: "100%", textAlign: "right" }} key={j}>
                                <span style={{ fontSize: 14 }}>{comboItem.snapshot?.name}</span>
                            </div>)}
                        </div>
                        <div>
                            {item.options && item.options.map((option, j) => <div style={{ width: "100%", textAlign: "right" }} key={j}>
                                <span style={{ fontSize: 14 }}>{option.snapshot?.name}</span>
                            </div>)}
                        </div>
                    </div>}
                    {item.notes && <span style={{
                        boxShadow: item.snapshot ? "inset 0 10px 4px -10px #00000050" : "none",
                        borderTop: item.snapshot ? "1px solid #00000050" : "none",
                        margin: "0 0 6px 0", display: "block", fontSize: 14, paddingTop: 10,
                    }}>{item.notes}</span>}
                </div>
            </div>)}
        </div>
    </div>;
}

export default OrderItems;